import { z } from 'zod';
import { ErrorCategory } from './notification.schema';

export const failedNotificationSchema = z.object({
  id: z.string(),
  to: z.string(),
  channel: z.string(),
  eventType: z.string(),
  status: z.string(),
  retryRound: z.number(),
  createdAt: z.string(),
  lastErrorCode: z.string().nullable().optional(),
  lastErrorCategory: ErrorCategory.nullable().optional(),
  lastAttemptAt: z.string().nullable().optional(),
  attemptsCount: z.number(),
  nextRetryAt: z.string().nullable().optional(),
});
export type FailedNotification = z.infer<typeof failedNotificationSchema>;
